import React from "react";
import {
  IPMSReportData,
} from "./ipmsmodel";
import { Department } from "./newipmsmodel";
import ReactDataTable from "./ReactDataTable";
import useIPMSApi from "./ipms";
import moment from "moment";
import { GoalsFlagListStatusEnum } from "./constant";
import { toast } from "react-toastify";
import SingleSelect from "../../components/SingleSelect";
import GoalModal, { GoalModalState } from "./GoalModal";
import AssessmentModal, { AssessmentModalState } from "./AssessmentModal";



interface filterForm {
  department: any | null;
  submission_status: number | null;
  month: string;
  year: number | null;
  report_status: any | null;
  from_date: Date | null;
  to_date: Date | null;
  status: any | null;
  advanced_status: any | null;
}

const IPMSReportPage: React.FC = () => {
  const [formValue, setFormValue] = React.useState<filterForm>({
    department: null,
    submission_status: null,
    month: "",
    year: null,
    report_status: null,
    from_date: null,
    to_date: null,
    status: null,
    advanced_status: null,
  });
  const [showFilter, setShowFilter] = React.useState<boolean>(false);
  const [loadings, setLoading] = React.useState<boolean>(false);
  const [goalModal, setGoalModal] = React.useState<GoalModalState | null>(null);
  const [assessmentModal, setAssessmentModal] = React.useState<AssessmentModalState | null>(null);
  const [reportList, setReportList] = React.useState<IPMSReportData[] | null>(
    null
  );
  const [departmentList, setDepartmentList] = React.useState<Department[] | null>(null);
  const [reportTypes, setReportTypes] = React.useState<string[]>([]);
  const [reportStatuses, setReportStatuses] = React.useState<Record<string, string[]>>({});
  const [yearList, setYearList] = React.useState<string[] | null>(null);
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const { fetchIPMSReportList, sendReminder } = useIPMSApi();

  const goalNotSubmittedColumns = [
    {
      name: "Employee Name",
      selector: (row: IPMSReportData) => (
        <span className=" text-wrap pl-8 block">{row.employee_name}</span>
      ),
      sortable: true,
      grow: 3,
    },
    {
      name: "Employee Id",
      selector: (row: IPMSReportData) => row.employeeid,
      sortable: true,
      center: true,
      width: "150px",
    },
    {
      name: "Manager Name",
      selector: (row: IPMSReportData) => (
        <span className=" text-wrap pl-8 block">{row.manager_name}</span>
      ),
      sortable: true,
      grow: 2,
    },
    {
      name: "Department",
      selector: (row: IPMSReportData) => (
        <span className=" text-wrap pl-8 block">{row.department}</span>
      ),
      sortable: true,
      grow: 2,
    },
    {
      name: "Date Of Joining",
      selector: (row: IPMSReportData) => row.doj,
      sortable: true,
      center: true,
      width: "150px",
    },
    {
      name: "Year",
      selector: (row: IPMSReportData) => row.year,
      sortable: true,
      center: true,
      width: "90px",
    },
    {
      name: "Goal Status",
      selector: (row: IPMSReportData) => row.goal_status || "Not Submitted",
      sortable: true,
      center: true,
      width: "140px",
    },
  ];

  const goalSubmittedColumns = [
    {
      name: "Employee Name",
      selector: (row: IPMSReportData) => (
        <span className=" text-wrap pl-8 block">{row.employee_name}</span>
      ),
      sortable: true,
      width: "240px",
    },
    {
      name: "Employee Id",
      selector: (row: IPMSReportData) => row.employeeid,
      sortable: true,
      center: true,
      width: "150px",
    },
    {
      name: "Manager Name",
      selector: (row: IPMSReportData) => (
        <span className=" text-wrap pl-8 block">{row.manager_name}</span>
      ),
      sortable: true,
      width: "240px",
    },
    {
      name: "Department",
      selector: (row: IPMSReportData) => (
        <span className=" text-wrap pl-8 block">{row.department}</span>
      ),
      sortable: true,
      width: "220px",
    },
    {
      name: "Date Of Joining",
      selector: (row: IPMSReportData) => row.doj,
      sortable: true,
      center: true,
      width: "150px",
    },
    {
      name: "Goal Status",
      selector: (row: IPMSReportData) => row.goal_status || "Submitted",
      sortable: true,
      center: true,
      width: "180px",
    },
    {
      name: "Submitted On",
      selector: (row: IPMSReportData) => row.employee_submitted_at,
      sortable: true,
      center: true,
      width: "150px",
    },
    {
      name: "Year",
      selector: (row: IPMSReportData) => row.year,
      sortable: true,
      center: true,
      width: "90px",
    },
  ];

  const assessmentNotSubmittedColumns = [
    {
      name: "Employee Name",
      selector: (row: IPMSReportData) => (
        <span className=" text-wrap pl-8 block">{row.employee_name}</span>
      ),
      sortable: true,
    },
    {
      name: "Employee Id",
      selector: (row: IPMSReportData) => row.employeeid,
      sortable: true,
      center: true,
    },
    {
      name: "Manager Name",
      selector: (row: IPMSReportData) => (
        <span className=" text-wrap pl-8 block">{row.manager_name}</span>
      ),
      sortable: true,
    },
    {
      name: "Date Of Joining",
      selector: (row: IPMSReportData) => row.doj,
      sortable: true,
      center: true,
    },
    // {
    //   name: "Quarter",
    //   selector: (row: IPMSReportData) => row.quarter,
    //   sortable: true,
    //   center: true,
    // },
    {
      name: "Year",
      selector: (row: IPMSReportData) => row.year,
      sortable: true,
      center: true,
      width: "90px",
    },
    {
      name: "Assessment Status",
      selector: (row: IPMSReportData) => row.assessment_status || "Not Submitted",
      sortable: true,
      center: true,
    }
  ];

  const assessmentSubmittedColumns = [
    {
      name: "Employee Name",
      selector: (row: IPMSReportData) => (
        <span className=" text-wrap pl-8 block">{row.employee_name}</span>
      ),
      sortable: true,
      grow: 3,
    },
    {
      name: "Employee Id",
      selector: (row: IPMSReportData) => row.employeeid,
      sortable: true,
      center: true,
      width: "150px",
    },
    {
      name: "Manager Name",
      selector: (row: IPMSReportData) => (
        <span className=" text-wrap pl-8 block">{row.manager_name}</span>
      ),
      sortable: true,
      grow: 3,
    },
    {
      name: "Date Of Joining",
      selector: (row: IPMSReportData) => row.doj,
      sortable: true,
      center: true,
      width: "150px",
    },
    // {
    //   name: "Quarter",
    //   selector: (row: IPMSReportData) => row.quarter,
    //   sortable: true,
    //   center: true,
    //   width: "90px",
    // },
    {
      name: "Year",
      selector: (row: IPMSReportData) => row.year,
      sortable: true,
      center: true,
      width: "90px",
    },
    {
      name: "Submitted On",
      selector: (row: IPMSReportData) => row.submitted_on,
      sortable: true,
      center: true,
      width: "150px",
    },
    {
      name: "Assessment Status",
      selector: (row: IPMSReportData) => row.assessment_status || "Submitted",
      sortable: true,
      center: true,
      width: "180px",
    }
  ];

  const assessmentApprovedColumns = [
    {
      name: "Employee Name",
      selector: (row: IPMSReportData) => (
        <span className=" text-wrap pl-8 block">{row.employee_name}</span>
      ),
      sortable: true,
      width: "240px",
    },
    {
      name: "Employee Id",
      selector: (row: IPMSReportData) => row.employeeid,
      sortable: true,
      center: true,
      width: "150px",
    },
    {
      name: "Manager Name",
      selector: (row: IPMSReportData) => (
        <span className=" text-wrap pl-8 block">{row.manager_name}</span>
      ),
      sortable: true,
      width: "220px",
    },
    {
      name: "Date Of Joining",
      selector: (row: IPMSReportData) => row.doj,
      sortable: true,
      center: true,
      width: "150px",
    },
    // {
    //   name: "Quarter",
    //   selector: (row: IPMSReportData) => row.quarter,
    //   sortable: true,
    //   center: true,
    //   width: "90px",
    // },
    {
      name: "Year",
      selector: (row: IPMSReportData) => row.year,
      sortable: true,
      center: true,
      width: "90px",
    },
    {
      name: "Submitted On",
      selector: (row: IPMSReportData) => row.employee_submitted_at,
      sortable: true,
      center: true,
      width: "150px",
    },
    {
      name: "Approved On",
      selector: (row: IPMSReportData) => row.manager_approved_at,
      sortable: true,
      center: true,
      width: "150px",
    },
    {
      name: "Bonus Rating",
      selector: (row: IPMSReportData) => row.bonus_rating,
      sortable: true,
      center: true,
      width: "140px",
    },
    {
      name: "Assessment Status",
      selector: (row: IPMSReportData) => row.assessment_status || "Approved",
      sortable: true,
      center: true,
      width: "180px",
    }
  ];

  const assessmentCompletedColumns = [
    {
      name: "Employee Name",
      selector: (row: IPMSReportData) => (
        <span className=" text-wrap pl-8 block">{row.employee_name}</span>
      ),
      sortable: true,
      width: "240px",
    },
    {
      name: "Employee Id",
      selector: (row: IPMSReportData) => row.employeeid,
      sortable: true,
      center: true,
      width: "150px",
    },
    {
      name: "Manager Name",
      selector: (row: IPMSReportData) => (
        <span className=" text-wrap pl-8 block">{row.manager_name}</span>
      ),
      sortable: true,
      width: "220px",
    },
    {
      name: "Date Of Joining",
      selector: (row: IPMSReportData) => row.doj,
      sortable: true,
      center: true,
      width: "150px",
    },
    // {
    //   name: "Quarter",
    //   selector: (row: IPMSReportData) => row.quarter,
    //   sortable: true,
    //   center: true,
    //   width: "90px",
    // },
    {
      name: "Year",
      selector: (row: IPMSReportData) => row.year,
      sortable: true,
      center: true,
      width: "90px",
    },
    {
      name: "Submitted On",
      selector: (row: IPMSReportData) => row.submitted_on,
      sortable: true,
      center: true,
      width: "150px",
    },
    {
      name: "Approved On",
      selector: (row: IPMSReportData) => row.managerapproved,
      sortable: true,
      center: true,
      width: "150px",
    },
    {
      name: "Bonus Rating",
      selector: (row: IPMSReportData) => row.bonus_rating,
      sortable: true,
      center: true,
      width: "140px",
    },
    {
      name: "Final Rating",
      selector: (row: IPMSReportData) => row.final_rating,
      sortable: true,
      center: true,
      width: "110px",
    },
    {
      name: "Assessment Status",
      selector: (row: IPMSReportData) => row.assessment_status || "Completed",
      sortable: true,
      center: true,
      width: "180px",
    }
  ];

  const columns5 = [
    {
      name: "Employee Name",
      selector: (row: IPMSReportData) => (
        <span className=" text-wrap pl-8 block">{row.employee_name}</span>
      ),
      sortable: true,
      width: "240px",
    },
    {
      name: "Employee Id",
      selector: (row: IPMSReportData) => row.employeeid,
      sortable: true,
      center: true,
      width: "150px",
    },
    {
      name: "Manager Name",
      selector: (row: IPMSReportData) => (
        <span className=" text-wrap pl-8 block">{row.manager_name}</span>
      ),
      sortable: true,
      width: "220px",
    },
    {
      name: "Duration",
      selector: (row: IPMSReportData) => row.duration,
      sortable: true,
      center: true,
      width: "180px",
    },

    // {
    //   name: "Quarter",
    //   selector: (row: IPMSReportData) => row.quarter,
    //   sortable: true,
    //   center: true,
    //   width: "90px",
    // },
    {
      name: "Year",
      selector: (row: IPMSReportData) => row.year,
      sortable: true,
      center: true,
      width: "90px",
    },
    {
      name: "KRA Rating Employee",
      selector: (row: IPMSReportData) => row.userrating,
      sortable: true,
      center: true,
      width: "100px",
    },
    {
      name: "KRA Rating Manager",
      selector: (row: IPMSReportData) => row.managerrating,
      sortable: true,
      center: true,
      width: "100px",
    },
    {
      name: "Softgoals Rating Employee",
      selector: (row: IPMSReportData) => row.userratingsoftgoals,
      sortable: true,
      center: true,
      width: "100px",
    },
    {
      name: "Softgoals Rating Manager",
      selector: (row: IPMSReportData) => row.managerratingsoftgoals,
      sortable: true,
      center: true,
      width: "100px",
    },
    {
      name: "Bonus Rating",
      selector: (row: IPMSReportData) => row.bonusrating,
      sortable: true,
      center: true,
      width: "100px",
    },
    {
      name: "Status",
      selector: (row: IPMSReportData) => (
        <span
          className={`${(GoalsFlagListStatusEnum[row.submission_status] ===
            GoalsFlagListStatusEnum[1] &&
            "bg-gray-100 text-gray-800 dark:text-gray-400 border-gray-500") ||
            (GoalsFlagListStatusEnum[row.submission_status] ===
              GoalsFlagListStatusEnum[2] &&
              "bg-blue-100 text-blue-800 dark:text-blue-400 border-blue-400") ||
            (GoalsFlagListStatusEnum[row.submission_status] ===
              GoalsFlagListStatusEnum[3] &&
              "bg-yellow-100 text-yellow-800 dark:text-yellow-300 border-yellow-300") ||
            (GoalsFlagListStatusEnum[row.submission_status] ===
              GoalsFlagListStatusEnum[4] &&
              "bg-green-100 text-green-800 dark:text-green-400 border-green-400")
            } border-0 text-xs font-medium  px-2.5 py-0.5 rounded dark:bg-gray-700 `}
        >
          {GoalsFlagListStatusEnum[row.submission_status]
            ? GoalsFlagListStatusEnum[row.submission_status]
            : "Not Added"}
        </span>
      ),
      sortable: true,
      center: true,
      width: "120px",
    },
  ];

  const getSkillsReport = React.useCallback(
    async (formValuess: filterForm) => {
      setLoading(true);
      try {
        const payload = {
          report_type: formValuess.report_status?.value || null,
          status: formValuess.status?.value || null,
          from_date: formValuess.from_date ? moment(formValuess.from_date).format("YYYY-MM-DD") : null,
          to_date: formValuess.to_date ? moment(formValuess.to_date).format("YYYY-MM-DD") : null,
          department: formValuess.department?.value || null,
        };
        const responseData: any = await fetchIPMSReportList(payload);
        console.log("responseData", responseData);

        if (!responseData) return;
        setReportList(responseData?.data as IPMSReportData[]);
        if (responseData?.departments?.length) {
          setDepartmentList(responseData.departments as Department[]);
        }
        setYearList(responseData?.years as string[]);
        if (responseData?.report_types?.length) {
          setReportTypes(responseData.report_types);
        }
        if (responseData?.statuses && Object.keys(responseData.statuses).length) {
          setReportStatuses(responseData.statuses);
        }
        // setSkillsReportList(responseData as skillsReportInterface[]);
        return responseData;
      } catch (error) {
        // setError(error.message);
      } finally {
        setLoading(false);
      }
    },
    [fetchIPMSReportList]
  );

  React.useEffect(() => {
    getSkillsReport(formValue);
  }, []);

  const handleSearchAction = React.useCallback(
    async (formValues: filterForm) => {
      if (!formValues?.report_status) {
        toast.error("Report Status is required");
        return;
      }
      if (!formValues?.from_date) {
        toast.error("From Date is required");
        return;
      }
      if (!formValues?.to_date) {
        toast.error("To Date is required");
        return;
      }
      if (formValues?.report_status?.value !== "Quarterly Ratings" && !formValues?.status) {
        toast.error("Status is required");
        return;
      }
      getSkillsReport(formValues);
    },
    []
  );

  const reportListData = React.useMemo<IPMSReportData[] | null>(() => {
    return reportList
      ? reportList.map((item) => {
        // Normalise date-of-joining — API sends `doj`; keep `dojs` as alias
        // so all column selectors continue to work without change.
        const rawDoj = item.doj ?? (item as any).doj ?? null;
        const formattedDoj = rawDoj && moment(rawDoj).isValid()
          ? moment(rawDoj).format("DD-MMM-YYYY")
          : null;

        // Normalise submitted / approved dates — API sends ISO strings under
        // new names; map once to the display names the columns use.
        // const formattedSubmitted = item.employee_submitted_at
        //   ? moment(item.employee_submitted_at).format("DD MMM YYYY")
        //   : item.submitted_on
        //     ? moment(item.submitted_on).format("DD MMM YYYY")
        //     : null;

        // const formattedApproved = item.manager_approved_at
        //   ? moment(item.manager_approved_at).format("DD MMM YYYY")
        //   : item.managerapproved
        //     ? moment(item.managerapproved).format("DD MMM YYYY")
        //     : null;
        const formattedSubmitted = item.employee_submitted_at
          ? moment(item.employee_submitted_at).format("DD MMM YYYY")
          : null;

        const formattedApproved = item.manager_approved_at
          ? moment(item.manager_approved_at).format("DD MMM YYYY")
          : null;

        return {
          ...item,
          //dojs: formattedDoj,             // single canonical DOJ (no duplicate doj/dojs)
          employee_submitted_at: formattedSubmitted,
          manager_approved_at: formattedApproved,
          quaterName: item.quarter ? "Q" + item.quarter : "",
        } as IPMSReportData;
      })
      : null;
  }, [reportList]);

  const handleEdit = (item: IPMSReportData, formData: filterForm) => {
    if (
      item.employeeid &&
      formData.report_status?.value === "Goal" && (formData.status?.value === "Submitted" || formData.status?.value === "Approved")
    ) {
      // Derive assessment year: prefer item.year (new API), then initiation_date, then doj year
      const yearstart = item.year
        ? Number(item.year)
        : item.initiation_date
          ? parseInt(item.initiation_date, 10)
          : item.doj
            ? moment(new Date(item.doj)).year()
            : moment().year();

      const startDate = moment(`${yearstart}-01-01`);
      const endDate = startDate.clone().add(1, "year");

      setGoalModal({
        employeeID: item.employeeid || item.employeeid,
        // employeeID: item.employeeid || item.employeeid,
        employeeName: item.employee_name || item.employee_name,
        start: startDate.format("YYYY-MM-DD"),
        end: endDate.format("YYYY-MM-DD"),
        quarterName: "q" + item.quarter,
      });
      return;
    }

    if (
      item.employeeid &&
      formData.report_status?.value === "Assessment" &&
      ["Submitted", "Approved", "Completed"].includes(formData.status?.value)
    ) {
      const yearstart = item.year
        ? Number(item.year)
        : item.initiation_date
          ? parseInt(item.initiation_date, 10)
          : item.doj
            ? moment(new Date(item.doj)).year()
            : moment().year();

      const startDate = moment(`${yearstart}-01-01`);
      const endDate = startDate.clone().add(1, "year");

      setAssessmentModal({
        id: item.quarter === 4 ? "1,2,3,4" : String(item.quarter),
        quarterName: "q" + item.quarter,
        employeeID: item.employeeid || item.employeeid,
        employeeName: item.employee_name || item.employee_name,
        submissionstatus: item.submission_status,
        assessmentData: {
          start: startDate.format("YYYY-MM-DD"),
          end: endDate.format("YYYY-MM-DD"),
        },
      });
    }
  };

  const handleRemainder = React.useCallback(
    async (item: IPMSReportData, formValueData: any) => {
      const isConfirm = window.confirm("Are you sure you want to send this reminder?");
      if (!isConfirm) return;

      try {
        setLoading(true);
        const reportType = formValueData?.report_status?.value || "Goal";
        const yearFallback = formValueData?.year ? Number(formValueData?.year) : new Date().getFullYear();

        const responseData: any = await sendReminder({
          reminders: [
            {
              employee_id: item?.employeeid || item?.employeeid || 0,
              name: item?.employee_name || item?.employee_name || "Employee",
              report_type: reportType,
              quarter: item?.quarter ?? 1,
              year: item?.year ? Number(item?.year) : yearFallback,
            }
          ]
        });
        return responseData;
      } catch (error) {
        // setError(error.message);
      } finally {
        setLoading(false);
      }
    },
    [sendReminder]
  );

  const handleBulkRemainder = React.useCallback(
    async () => {
      if (!reportListData || reportListData.length === 0) return;

      const isConfirm = window.confirm(`Are you sure you want to send reminders to all ${reportListData.length} employees?`);
      if (!isConfirm) return;

      try {
        setLoading(true);
        const reportType = formValue?.report_status?.value || "Goal";
        const fallbackYear = formValue?.year ? Number(formValue?.year) : new Date().getFullYear();

        const reminders = reportListData.map(item => ({
          employee_id: item?.employeeid || item?.employeeid || 0,
          name: item?.employee_name || item?.employee_name || "Employee",
          report_type: reportType,
          quarter: item?.quarter ?? 1,
          year: item?.year ? Number(item?.year) : fallbackYear,
        }));

        const responseData: any = await sendReminder({ reminders });
        return responseData;
      } catch (error) {
        // handle error
      } finally {
        setLoading(false);
      }
    },
    [sendReminder, reportListData, formValue]
  );

  if (loadings) {
    return <div>Loading...</div>;
  }

  return (
    <>
      {formValue?.submission_status &&
        [1, 2].includes(formValue?.submission_status) && (
          <div>
            <span className="bg-gray-100 text-gray-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-400 border border-gray-500">
              Employee Not Submitted
            </span>
            <span className="bg-gray-100 text-gray-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-400 border border-gray-500">
              Employee Saved
            </span>
            <span className="bg-blue-100 text-blue-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-blue-400 border border-blue-400">
              Employee Added
            </span>
            {/* <span className='bg-yellow-100 text-yellow-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-yellow-300 border border-yellow-300'>
        Manager Approved
      </span> */}
            <span className="bg-green-100 text-green-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-green-400 border border-green-400">
              Manager Approved
            </span>
          </div>
        )}

      {formValue?.submission_status &&
        [3, 4, 5, 6].includes(formValue?.submission_status) && (
          <div>
            <span className="bg-gray-100 text-gray-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-400 border border-gray-500">
              Employee Not Added
            </span>
            <span className="bg-gray-100 text-gray-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-400 border border-gray-500">
              Employee Saved
            </span>
            <span className="bg-blue-100 text-blue-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-blue-400 border border-blue-400">
              Employee Added
            </span>
            <span className="bg-yellow-100 text-yellow-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-yellow-300 border border-yellow-300">
              Manager Approved
            </span>
            <span className="bg-green-100 text-green-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-green-400 border border-green-400">
              HR Approved
            </span>
          </div>
        )}

      <div className="flex flex-wrap items-end px-0 my-2 gap-4 p-4">

        {/* Report Status */}
        <div className="flex-1 min-w-[200px]">
          <label className="block text-sm font-medium text-gray-700">
            Items <span className="text-red-500">*</span>
          </label>
          <SingleSelect
            value={formValue?.report_status}
            onChange={(selected: any) => {
              setFormValue({
                ...formValue,
                report_status: selected,
                status: null,
              });
              setReportList([]);
            }}
            options={
              reportTypes.length
                ? reportTypes.map((type) => ({ value: type, label: type === "Goal" ? "Goals" : type === "Assessment" ? "Assessments" : type }))
                : [
                  { value: "Goal", label: "Goals" },
                  { value: "Assessment", label: "Assessments" },
                  { value: "Quarterly Ratings", label: "Quarterly Ratings" },
                ]
            }
            placeholder="Select Items"
          />
        </div>

        {/* Status */}
        {formValue?.report_status?.value !== "Quarterly Ratings" && (
          <div className="flex-1 min-w-[200px]">
            <label className="block text-sm font-medium text-gray-700">
              Status <span className="text-red-500">*</span>
            </label>
            <SingleSelect
              value={formValue?.status}
              onChange={(selected: any) => {
                setFormValue({
                  ...formValue,
                  status: selected,
                });
                setReportList([]);
              }}
              options={
                (() => {
                  const selectedType = formValue?.report_status?.value;
                  const apiStatuses = selectedType ? reportStatuses[selectedType] : undefined;
                  if (apiStatuses?.length) {
                    return apiStatuses.map((s) => ({ value: s, label: s }));
                  }
                  // Fallback to hardcoded defaults
                  return [
                    { value: "Not Submitted", label: "Not Submitted" },
                    { value: "Submitted", label: "Submitted" },
                    ...(selectedType === "Goal" ? [{ value: "Approved", label: "Approved" }] : []),
                    ...(selectedType === "Assessment" ? [{ value: "Completed", label: "Completed" }] : []),
                  ];
                })()
              }
              placeholder="Select Status"
            />
          </div>
        )}

        {/* From Date */}
        <div className="flex-1 min-w-[200px]">
          <label className="block text-sm font-medium text-gray-700">
            From <span className="text-red-500">*</span>
          </label>
          <input
            type="date"
            value={
              formValue?.from_date
                ? moment(formValue.from_date).format("YYYY-MM-DD")
                : ""
            }
            onChange={(e) => {
              const selectedDate = e.target.value ? new Date(e.target.value) : null;
              let toDate = formValue.to_date;
              if (selectedDate) {
                toDate = moment(selectedDate).add(1, 'months').toDate();
              }
              setFormValue({ ...formValue, from_date: selectedDate, to_date: toDate });
            }}
            className="mt-2 block w-full text-sm border p-[9px] rounded-md border-gray-200 shadow-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500 hover:border-blue-500 outline-none transition-colors duration-200"
          />
        </div>

        {/* To Date */}
        <div className="flex-1 min-w-[200px]">
          <label className="block text-sm font-medium text-gray-700">
            To <span className="text-red-500">*</span>
          </label>
          <input
            type="date"
            value={
              formValue?.to_date
                ? moment(formValue.to_date).format("YYYY-MM-DD")
                : ""
            }
            onChange={(e) => {
              const selectedDate = e.target.value ? new Date(e.target.value) : null;
              setFormValue({ ...formValue, to_date: selectedDate });
            }}
            className="mt-2 block w-full text-sm border p-[9px] rounded-md border-gray-200 shadow-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500 hover:border-blue-500 outline-none transition-colors duration-200"
          />
        </div>

        {/* Month */}
        {formValue?.submission_status &&
          formValue?.submission_status !== 0 &&
          [8, 9, 10].includes(formValue?.submission_status) && (
            <div className="flex-1 min-w-[200px]">
              <label className="block text-sm font-medium text-gray-700">
                Month
              </label>
              <select
                value={formValue?.month ?? ""}
                onChange={(e) =>
                  setFormValue({ ...formValue, month: e.target.value })
                }
                className="mt-1 block w-full  border p-1 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
              >
                <option value="">Select Month</option>
                {months.map((month, index) => (
                  <option key={index} value={month}>
                    {month}
                  </option>
                ))}
              </select>
            </div>
          )}

        {/* Custom Select Box */}
        {formValue?.submission_status &&
          formValue?.submission_status !== 0 &&
          ![5, 9, 6].includes(formValue?.submission_status) && (
            <div className="flex-1 min-w-[200px]">
              <label className="block text-sm font-medium text-gray-700">
                Year
              </label>
              <select
                value={formValue?.year ?? ""}
                onChange={(e) =>
                  setFormValue({ ...formValue, year: Number(e.target.value) })
                }
                className="mt-1 block w-full border p-1 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
              >
                <option value="">Select year</option>
                {yearList?.map((year, index) => (
                  <option key={index} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
          )}
        <div>
          <button
            onClick={() => handleSearchAction(formValue)}
            className=" mt-4 px-4 py-2 bg-blue-500 text-white rounded"
          >
            Generate
          </button>
        </div>
      </div>

      <div className="px-4 -mt-2 mb-2">
        <button
          onClick={() => setShowFilter(!showFilter)}
          className="text-blue-500 text-sm hover:underline font-medium"
        >
          {showFilter ? "- Hide Filter" : "+ Filter"}
        </button>
      </div>

      {showFilter && (
        <div className="flex flex-wrap items-end px-0 my-2 gap-4 p-4 pt-0">
          <div className="flex-1 min-w-[200px] max-w-xs">
            <label className="block text-sm font-medium text-gray-700">
              Department
            </label>
            <SingleSelect
              value={formValue?.department}
              onChange={(selected: any) => {
                setFormValue({
                  ...formValue,
                  department: selected,
                });
                setReportList([]);
              }}
              options={
                departmentList
                  ? [
                    { value: "", label: "All Department" },
                    ...departmentList.map((dept) => ({
                      value: dept.id,
                      label: dept.name,
                    })),
                  ]
                  : []
              }
              placeholder="All Department"
            />
          </div>

        </div>
      )}


      <p className="text-gray-500 text-sm mt-3">
        Note: Action buttons are only available when the date of join is
        present.
      </p>
      {formValue?.report_status?.value === "Goal" && formValue?.status?.value === "Not Submitted" && (
        <ReactDataTable
          columns={goalNotSubmittedColumns}
          data={Array.isArray(reportListData) ? reportListData : []}
          onRemainder={(e: IPMSReportData) => handleRemainder(e, formValue)}
          onBulkRemainder={handleBulkRemainder}
          //dateOfJoinAction={"doj"}
          headerColor={"green"}
          excelSheetHeader={[]}
          ReportName={"Goals_not_submitted"}
          showExport={true}
          searchLabelName=""
          showFilter={reportListData ? true : false}
        // onDelete={confirmDelete}
        />
      )}
      {formValue?.report_status?.value === "Goal" && (formValue?.status?.value === "Submitted" || formValue?.status?.value === "Approved") && (
        <ReactDataTable
          columns={goalSubmittedColumns}
          data={Array.isArray(reportListData) ? reportListData : []}
          onView={(e) => handleEdit(e, formValue)}
          headerColor={"green"}
          searchLabelName=""
          excelSheetHeader={[]}
          ReportName={"submitted_goals"}
          showExport={true}
          showFilter={reportListData ? true : false}
        // onDelete={confirmDelete}
        />
      )}

      {formValue?.report_status?.value === "Assessment" && formValue?.status?.value === "Not Submitted" && (
        <ReactDataTable
          columns={assessmentNotSubmittedColumns}
          data={Array.isArray(reportListData) ? reportListData : []}
          onRemainder={(e: IPMSReportData) => handleRemainder(e, formValue)}
          onBulkRemainder={handleBulkRemainder}
          //dateOfJoinAction={"doj"}
          headerColor={"green"}
          searchLabelName=""
          excelSheetHeader={[]}
          ReportName={"Assessment_not_submitted"}
          showExport={true}
          showFilter={reportListData ? true : false}
        // onDelete={confirmDelete}
        />
      )}

      {formValue?.report_status?.value === "Assessment" && formValue?.status?.value === "Submitted" && (
        <ReactDataTable
          columns={assessmentSubmittedColumns}
          data={Array.isArray(reportListData) ? reportListData : []}
          onView={(e) => handleEdit(e, formValue)}
          headerColor={"green"}
          searchLabelName=""
          excelSheetHeader={[]}
          ReportName={"Assessment_submitted"}
          showExport={true}
          showFilter={reportListData ? true : false}
        // onDelete={confirmDelete}
        />
      )}

      {formValue?.report_status?.value === "Assessment" && formValue?.status?.value === "Approved" && (
        <ReactDataTable
          columns={assessmentApprovedColumns}
          data={Array.isArray(reportListData) ? reportListData : []}
          onView={(e) => handleEdit(e, formValue)}
          headerColor={"green"}
          searchLabelName=""
          excelSheetHeader={[]}
          ReportName={"Assessment_approved"}
          showExport={true}
          showFilter={reportListData ? true : false}
        // onDelete={confirmDelete}
        />
      )}

      {formValue?.report_status?.value === "Assessment" && formValue?.status?.value === "Completed" && (
        <ReactDataTable
          columns={assessmentCompletedColumns}
          data={Array.isArray(reportListData) ? reportListData : []}
          onView={(e) => handleEdit(e, formValue)}
          headerColor={"green"}
          searchLabelName=""
          excelSheetHeader={[]}
          ReportName={"Assessment_completed"}
          showExport={true}
          showFilter={reportListData ? true : false}
        // onDelete={confirmDelete}
        />
      )}

      {formValue?.submission_status &&
        [7].includes(formValue?.submission_status) && (
          <ReactDataTable
            columns={columns5}
            data={Array.isArray(reportListData) ? reportListData : []}
            //dateOfJoinAction={"doj"}
            headerColor={"green"}
            searchLabelName=""
            excelSheetHeader={[]}
            ReportName={"Quarter_Ratings"}
            showExport={true}
            actionOption={false}
            showFilter={reportListData ? true : false}
          // onDelete={confirmDelete}
          />
        )}
      {/* Goal detail modal */}
      <GoalModal
        modalState={goalModal}
        onClose={() => setGoalModal(null)}
      />
      {/* Assessment detail modal */}
      <AssessmentModal
        modalState={assessmentModal}
        onClose={() => setAssessmentModal(null)}
      />
    </>
  );
};

export default IPMSReportPage;

// Force hot reload

// Force hot reload 2

// Force hot reload 3

// Force hot reload 4

// Force hot reload 5

// Force hot reload 6

// Force hot reload 7

// Force hot reload 8

// Force hot reload 9
